import React, { useState, useEffect } from 'react';
import { Button, Form, Modal, Col, Row, InputGroup, FormControl, Container, Table, Card, CardBody, CardHeader } from 'react-bootstrap';
import { apiFetch } from '../services/apiService';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faFileCirclePlus, faCartPlus } from '@fortawesome/free-solid-svg-icons';
import styles from '../../src/assets/styles/Menu.module.scss';

const ModalEditMenu = ({ menuCategories, setMenuCategories }) => {
    const [show, setShow] = useState(false);
    // Inicializujeme stav komponenty na základě předaných props
    const [categories, setCategories] = useState(menuCategories);

    useEffect(() => {
        setCategories(menuCategories); // Aktualizujeme, pokud se props změní
    }, [menuCategories]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleCategoryChange = (index, event) => {
        const newCategories = [...categories];
        newCategories[index].title = event.target.value;
        setCategories(newCategories);
    };

    const handleItemChange = (categoryIndex, itemIndex, field, value) => {
        const newCategories = [...categories];
        newCategories[categoryIndex].items[itemIndex][field] = value;
        setCategories(newCategories);
    };

    const addCategory = () => {
        setCategories([...categories, { title: '', items: [{ title: '', price: '', description: '' }] }]);
    };

    const handleSubmit = async () => {
        try {
            // Odeslání aktualizovaného stavu menu na server
            const response = await apiFetch('/api/menu/updateAndFetchMenu', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ categories }),
            });
            // Aktualizace lokálního stavu s daty vrácenými z API
            setMenuCategories(response);
            handleClose();
        } catch (error) {
            console.error('Chyba při pokusu editovat menu:', error);
        }
    };


    const addItemAbove = (categoryIndex, itemIndex) => {
        const newCategories = [...categories];
        // Vytvoření nové prázdné položky
        const newItem = { title: '', price: '', description: '' };
        // Vložení nové položky na specifické místo v seznamu
        newCategories[categoryIndex].items.splice(itemIndex, 0, newItem);
        setCategories(newCategories);
    };

    const addCategoryAbove = (index) => {
        const newCategories = [...categories];
        const newCategory = { title: '', items: [{ title: '', price: '', description: '' }] };
        newCategories.splice(index, 0, newCategory);
        setCategories(newCategories);
    };

    const deleteMenuItem = (categoryIndex, itemIndex) => {
        // Vytvoříme hlubokou kopii kategorií, abychom předešli mutaci původního stavu
        const newCategories = categories.map((category, idx) => {
            if (idx === categoryIndex) {
                // Vytvoříme novou kopii položek bez té, kterou chceme odstranit
                const newItems = [...category.items];
                newItems.splice(itemIndex, 1);
                return { ...category, items: newItems };
            }
            return category;
        });

        setCategories(newCategories);
    };

    useEffect(() => {
        console.log(categories);
    }, [categories]);

    const deleteMenuCategory = (categoryId) => {
        // Odstranění kategorie a jejích položek z lokálního stavu
        const updatedCategories = categories.filter(category => category.id !== categoryId);
        setCategories(updatedCategories);
    };



    return (
        <div>
            <Button variant="outline-dark" size='sm' onClick={handleShow} className='ms-3'>
                Editovat
            </Button>

            <Modal show={show} onHide={handleClose} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Editovat Menu</Modal.Title>
                </Modal.Header>
                <Modal.Body className={styles.menu}>
                    <Form className='d-flex flex-column justify-content-center'>
                        <Container fluid className='g-0'>
                            <Row>
                                {categories.map((category, categoryIndex) => (
                                    <Col xs={12} key={categoryIndex} className='d-flex flex-column justify-content-center'>
                                        <Button variant="outline-primary" size="sm" onClick={() => addCategoryAbove(categoryIndex)}>
                                            Přidat kategorii zde
                                        </Button>
                                        <Card className='mb-4'>
                                            <CardHeader className='d-flex flex-row'>
                                                <Form.Group as={Row} controlId="formHorizontalEmail" className='flex-grow-1'>
                                                    <Form.Label column className='d-flex align-items-center col-auto'>
                                                        Kategorie
                                                    </Form.Label>
                                                    <Col>
                                                        <FormControl
                                                            className='text-center fw-bold fs-4'
                                                            value={category.title}
                                                            onChange={(event) => handleCategoryChange(categoryIndex, event)}
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <div class="ms-2">
                                                    <Button variant='outline-danger' size='sm' className='h-100 px-3 rounded-1' onClick={(event) => deleteMenuCategory(category.id)}>
                                                        <FontAwesomeIcon icon={faTrashCan} />
                                                    </Button>
                                                </div>
                                            </CardHeader>
                                            <CardBody>
                                                <Table table-borderless hover size="sm">

                                                    <tbody>
                                                        {category.items.map((item, itemIndex) => (
                                                            <React.Fragment key={itemIndex}>
                                                                <tr>
                                                                    <td colSpan={4}>
                                                                        <Button variant="outline-secondary" size="sm" className="border-0" onClick={() => addItemAbove(categoryIndex, itemIndex)}>
                                                                            <FontAwesomeIcon icon={faCartPlus} /> Přidat položku zde
                                                                        </Button>
                                                                    </td>
                                                                </tr>
                                                                <tr key={itemIndex}>
                                                                    <td>
                                                                        <Form.Control
                                                                            className='fw-bolder'
                                                                            placeholder="Název položky"
                                                                            size="sm"
                                                                            value={item.title}
                                                                            onChange={(event) => handleItemChange(categoryIndex, itemIndex, 'title', event.target.value)}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <InputGroup size="sm">
                                                                            <Form.Control
                                                                                placeholder="Cena"
                                                                                size="sm"
                                                                                value={item.price}
                                                                                onChange={(event) => handleItemChange(categoryIndex, itemIndex, 'price', event.target.value)}
                                                                            />
                                                                            <InputGroup.Text size="sm">Kč</InputGroup.Text>
                                                                        </InputGroup>
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            placeholder="Popis"
                                                                            size="sm"
                                                                            value={item.description}
                                                                            onChange={(event) => handleItemChange(categoryIndex, itemIndex, 'description', event.target.value)}
                                                                        />
                                                                    </td>
                                                                    <td className='d-flex justify-content-end'>
                                                                        <Button variant='outline-danger' size='sm' onClick={(event) => deleteMenuItem(categoryIndex, itemIndex)}>
                                                                            <FontAwesomeIcon icon={faTrashCan} />
                                                                        </Button>
                                                                    </td>
                                                                </tr>
                                                            </React.Fragment>
                                                        ))}
                                                        <tr>
                                                            <td colSpan={4}>
                                                                <Button variant="outline-secondary" size="sm" className="border-0" onClick={() => addItemAbove(categoryIndex, category.items.length)}>
                                                                    <FontAwesomeIcon icon={faCartPlus} /> Přidat položku na konec
                                                                </Button>
                                                            </td>

                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Container>
                        <Button variant="outline-dark" onClick={addCategory}>Přidat kategorii zde</Button>

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={handleClose}>Zrušit editaci</Button>
                    <Button variant="outline-info" onClick={handleSubmit}>Uložit menu</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ModalEditMenu;
